export default __webpack_public_path__ + "static/media/occipital_eeg.71fa4931.webp";